import { render, staticRenderFns } from "./HeadIndex.vue?vue&type=template&id=2b0df2c5&scoped=true&"
import script from "./HeadIndex.vue?vue&type=script&lang=js&"
export * from "./HeadIndex.vue?vue&type=script&lang=js&"
import style0 from "./HeadIndex.vue?vue&type=style&index=0&id=2b0df2c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0df2c5",
  null
  
)

export default component.exports